"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIdService = exports.UserIdService = exports.AccessMethodId = void 0;
var models_1 = require("./models");
Object.defineProperty(exports, "AccessMethodId", { enumerable: true, get: function () { return models_1.AccessMethodId; } });
var user_id_service_1 = require("./user-id.service");
Object.defineProperty(exports, "UserIdService", { enumerable: true, get: function () { return user_id_service_1.UserIdService; } });
Object.defineProperty(exports, "userIdService", { enumerable: true, get: function () { return user_id_service_1.userIdService; } });
